module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-footer.ab782945.png";